// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__VChIS","iconWrapper":"styles_iconWrapper__EI0TG","label":"styles_label__psXYR","tabs":"styles_tabs__G_BKg"};